import React from 'react';
import {LocaleMenuItemWrapper} from '@homeaway/react-locale-switcher';

export class LocaleSwitcherMenu extends React.Component {
    renderItem = (item) => {
        return (
            <div
                className="site-header-tray__menu-item-link"
                key={item.locale}
            >
                <LocaleMenuItemWrapper
                    locale={item.locale}
                    countryName={item.countryName}
                    languageName={item.languageName}
                    basePath={item.basePath}
                    link={item.link}
                />
            </div>
        );
    }

    render() {
        return (
            <div className="site-header-tray__menu site-header-tray__drawer">
                <div className="site-header-tray__items">
                    {this.props.localeSwitcher.locales.map(this.renderItem)}
                </div>
            </div>
        );
    }
}
